var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoxBlue2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7904_71334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 37,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8571 26.2856V14.6485C37.8571 12.9703 36.9311 11.429 35.4495 10.6408L20.8755 2.88872C19.5784 2.19881 18.0277 2.17927 16.7137 2.83627L4.29492 9.04566C2.75707 9.81459 1.78564 11.3864 1.78564 13.1058V25.7332C1.78564 27.4526 2.75707 29.0244 4.29493 29.7933L19.0876 37.1897C20.4338 37.8627 22.026 37.8248 23.3385 37.0885L35.5386 30.2446C36.9705 29.4413 37.8571 27.9274 37.8571 26.2856Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7904_71334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8572 11.8053L21.0674 20.4215L1.85352 10.2943L18.4681 1.82812L37.8572 11.8053Z",
    fill: "#A9D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8567 28.912L21.0669 38.2569V20.4209L37.8567 11.8047V28.912Z",
    fill: "#3F8CEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85352 10.2891V28.4323L21.0674 38.2523V20.4163L1.85352 10.2891Z",
    fill: "#81BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05371 13.5703V18.3321L9.93076 17.8605L12.4693 21.0862L12.598 15.9637L8.05371 13.5703Z",
    fill: "#DCDCEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8193 7.16148L24.0605 4.71094L8.05371 13.57L12.598 15.9634L28.8193 7.16148Z",
    fill: "#F0F3FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxBlue2);
export default __webpack_public_path__ + "static/media/icon-box-blue2.a2b447f5a2d865e0eaffd300e7a44109.svg";
export { ForwardRef as ReactComponent };